import React from "react";
import { useHistory } from "react-router-dom";
import useObtenerSubsecciones from "../../js/translations/useObtenerSubsecciones";

/**
 * Este componente renderiza el primer paso al agendar una cita. En este se encuentran los botones de selección de idioma, los cuales cambian el path de la url indicando el calendario que se debe cargar.  
 */
const BotonesCita = ({onClickSpanishMeet}) => {
  const { isReady, textosSubSecciones: textos } = useObtenerSubsecciones('tienda_makemake');
  const history = useHistory();
  return (
    <>
      {isReady &&
        <div className="h-100 d-lg-flex flex-column justify-content-center">
          <h2 className="titulo-institucional mt-5">{textos?.institucional?.descripcion || '¡Muy bien! Vamos a agendar una cita contigo para saber exáctamente que necesita tu institución. '}</h2>

          <div className="d-md-flex justify-content-center container-botones">
            <div className="col-xl-6">
              <button
                className="btn-cita"
                onClick={() => onClickSpanishMeet&&onClickSpanishMeet()}
              >{textos?.institucional?.btn_espanol || 'Cita con Andrea en español'}</button>
            </div>
            {/* <div className="col-md-6">
              <button
                className="btn-cita"
                onClick={() => history.push('/tienda/institucional?idioma=en')}
              >{textos?.institucional?.btn_ingles || 'Cita con Catalina en inglés'}</button>
            </div> */}
          </div>
        </div>
      }
    </>
  )
}
export default BotonesCita;